<script>
  import { SPRITESHEET_URL } from '../../utils/constants';

  let { headingText, setLocationText, pharmaciesText, icon, extraTopMargin = false, onClick = () => {} } = $props();
</script>

<div class="mb-4 lg:mb-6" class:lg:mt-10={extraTopMargin} class:mt-4={!extraTopMargin}>
  <button
    class="bg-white w-full p-4 pt-2 lg:p-6 text-left rounded-lg shadow-y-sm pseudo-shadow-hover
    active:shadow-active group border border-gray-light-silver relative"
    onclick={onClick}
  >
    <h2 class="text-lg md:text-1.5xl font-semibold text-black mb-2">
      {headingText}
    </h2>
    <div class="flex group text-blue-cerulean hover-hover:group-hover:text-blue-darkish group-active:text-blue-darkish">
      <svg class="fill-current h-8 w-8 mr-2 inline-block" role="presentation">
        <use xlink:href="{SPRITESHEET_URL}#{icon}" />
      </svg>
      <div>
        <span class="md:text-lg font-semibold hover-hover:group-hover:underline group-active:underline">
          {setLocationText}
        </span>
        <span class="md:text-lg text-gray-brownish">{pharmaciesText}</span>
      </div>
    </div>
  </button>
</div>
